import React from 'react';

const defaultValue = {
  name: null,
};

export const PersonContext = React.createContext(defaultValue);
